import React from 'react';
import './ComprehensiveReports.css';

// Import the report images
import report1 from '../../assets/images/report-page-1.png';
import report2 from '../../assets/images/report-page-2.png';
import report3 from '../../assets/images/report-page-3.png';

const ComprehensiveReports = () => {
  return (
    <section className="comprehensive-reports-section">
      <div className="comprehensive-reports-container">
        {/* Left Column: Text Content */}
        <div className="reports-text-col">
          <h2>Comprehensive reports</h2>
          <p>
            Access reports in daily, weekly, or monthly formats based on your market needs. Get sector-specific insights across various crops, raw materials, and more, powered by CRISHI's proprietary, regionally-tuned price data.
          </p>
        </div>

        {/* Right Column: Layered Images */}
        <div className="reports-image-col">
          <img src={report1} alt="Report page 1" className="report-image-1" />
          <img src={report2} alt="Report page 2" className="report-image-2" />
          <img src={report3} alt="Report page 3" className="report-image-3" />
        </div>
      </div>
    </section>
  );
};

export default ComprehensiveReports;